import ApplicationController from "./application_controller";

export default class extends ApplicationController {
  static targets = ['panel']

  toggle() {
    this.panelTarget.classList.toggle('d-none')
  }

  close() {
    this.panelTarget.classList.add('d-none')
  }
}
